export enum StorageEnum {
	GITLAB_TOKEN = 'gitlab_token',
	GITLAB_REFRESHTOKEN = 'gitlab_refreshtoken',
	GITLAB_PERSONAL_TOKEN = 'gitlab_personal_token',
	GITLAB_PIPELINE_TOKEN = 'gitlab_pipeline_token',
	CALLBACK_PAGE = 'callback_page',

	BITRISE_TOKEN = 'bitrise_token',

	REFRESH_MINUTES = 'refresh_minutes',
	HEADER_EXPANDED = 'headerExpanded',

	B2C_OFFLINES = 'b2c_offlines',
	S1_MOBILE_OFFLINES = 's1_offlines',

	S1_DISTRIBUTIONS = 's1_distributions',
	B2C_DISTRIBUTIONS = 'b2c_distributions',

	RELEASE_NOTES = 'release_notes',
}
